import React, { FC, useEffect, useState } from 'react';

import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { SessionStorage } from '@pp/core/src/storage/session/SessionStorage';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { useAirPlaneSlice } from '../../store/slices/highflyerAirPlane/selectors';
import { airplaneStates } from '../../store/slices/highflyerAirPlane/types';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';

import { Animation } from './Animation';

export const AnimationConnected: FC = () => {
  const airplaneCurrentState = useAirPlaneSlice.getcurrentState();
  const isAnimating = useAirPlaneSlice.isAnimating();
  const multiplier = useHighflyerStateSlice.getMultiplier() || 1;
  const isSBBEnabled = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();
  const isAnimationToggle = useHighflyerGameStateSlice.getAnimationToggle();
  const isJackpot = useHighflyerGameStateSlice.getJackpot();

  const audioTrigger = useAudioTrigger();
  const isChatClosed = useHighflyerGameStateSlice.getChatClosed();
  const getTheme = (): string => {
    const params = new URLSearchParams(window.location.search);
    try {
      const theme =
        params.get('operator_theme') ||
        (() => {
          const value = SessionStorage.get('PPG');
          return value && JSON.parse(value).operator_theme;
        })();
      return theme || 'default';
    } catch (e) {
      return 'default';
    }
  };
  const [theme] = useState(getTheme());
  const [isFlagAvailable, setIsFlagAvailable] = useState(false);
  const gameType = useConfigSlice.getGameType();
  useEffect(() => {
    const BASE_URL = `${window.location.origin}/apps/themes/1.0.0/games/${gameType}`;
    const flagURL = `${BASE_URL}/${theme}/animation/flag.svg`;

    const checkFlag = async () => {
      try {
        const response = await fetch(flagURL);
        setIsFlagAvailable(response.ok);
      } catch (error) {
        console.error('Error fetching the flag:', error);
        setIsFlagAvailable(false);
      }
    };
    checkFlag();
  }, [theme]);

  useEffect(() => {
    if (airplaneCurrentState === airplaneStates.FLYING) {
      audioTrigger.play({ name: 'StartBeep' });
    }
    if (airplaneCurrentState === airplaneStates.FLEW_AWAY) {
      audioTrigger.play({ name: 'crashV2' });
    }
  }, [airplaneCurrentState, audioTrigger]);

  return (
    <Animation
      airplaneCurrentState={airplaneCurrentState}
      multiplier={multiplier}
      isSBBEnabled={isSBBEnabled}
      isChatClosed={isChatClosed}
      isJackpot={isJackpot}
      isAnimating={isAnimating}
      isAnimationToggle={isAnimationToggle}
      theme={theme}
      isFlagAvailable={isFlagAvailable}
    />
  );
};
